import React, { Component } from "react";
import Icon from "@alboompro/boom-components/general/icon";
import {
  ButtonCarousel,
  CarouselWrapper,
  BulletsWrapper,
  ImageWrapper,
  Image,
  OptionWrapper,
  OptionName
} from "./styles";

class CarouselComponent extends Component {
	radionext = (e) => {
		const { name, updateFunction } = this.props;

		updateFunction({
			prop: name,
			value: e.target.value,
		});
	};

  createSlides = () => {
    const { slides, currentValue } = this.props;
    const hasName = this.hasName();

    return slides.map((option) => (
      <OptionWrapper 
        className={currentValue === option.value && "active"}
        style={{height: option.height || ""}}
        hasName={hasName}
      >
        { typeof option.image === "string" && option.image.includes("http") ?
          <Image
            src={option.image}
            alt="carousel"
            height={option.height || ""}
          /> : option.image
        }
        {
          option.name && <OptionName>{option.name}</OptionName>
        }
      </OptionWrapper>
    ));
  }
	
  hasName = () => {
    const { slides } = this.props;

    return slides.some((option) => !!option.name);
  }

	next() {
		const { slides, name, currentValue, updateFunction } = this.props;

		const currentIndex = slides.findIndex(
			(option) => option.value === currentValue
		);
		let newIndex = currentIndex + 1;

		if (newIndex === slides.length) {
			newIndex = 0;
		}

		updateFunction({
			prop: name,
			value: slides[newIndex].value,
		});
	}
	
	prev() {
		const { slides, name, currentValue, updateFunction } = this.props;

		const currentIndex = slides.findIndex(
			(option) => option.value === currentValue
		);
		let newIndex = currentIndex - 1;

		if (newIndex < 0) {
			newIndex = slides.length - 1;
		}

		updateFunction({
			prop: name,
			value: slides[newIndex].value,
		});
	}

	render() {
		const { slides, currentValue } = this.props;
    const hasName = this.hasName();

		return (
			<div>
				<CarouselWrapper>
					<ButtonCarousel hasName={hasName} onClick={() => this.prev()}>
						<Icon
  kind="bold"
  group="arrows-diagrams"
  category="arrows"
  file="arrow-button-left.svg"
  size="12"
  color="#515151"
						/>
					</ButtonCarousel>
					<ImageWrapper>
            {this.createSlides()}
					</ImageWrapper>
					<ButtonCarousel hasName={hasName} onClick={() => this.next()}>
						<Icon
  kind="bold"
  group="arrows-diagrams"
  category="arrows"
  file="arrow-button-right.svg"
  size="12"
  color="#515151"
						/>
					</ButtonCarousel>
				</CarouselWrapper>
				<BulletsWrapper>
					{slides.map((option) => (
						<input
  type="radio"
  value={option.value}
  checked={currentValue === option.value}
  onChange={this.radionext}
						/>
					))}
				</BulletsWrapper>
			</div>
		)
	}
}

export default CarouselComponent;